import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { GETCOWORKER_REQ } from "../../actions";
import { GeneralSettings } from "./general";
import { SecuritySettings } from "./security";

function Settings() {
  const dispatch = useDispatch();
  useEffect(() => {
    const _coworker = JSON.parse(localStorage.getItem("user"));
    if (_coworker?.coworker_uid)
      dispatch(GETCOWORKER_REQ({ coworker_uid: _coworker.coworker_uid }));
  }, []);

  const navs = [
    {
      name: "General",
      logo: (
        <svg
          class="h-6 w-6 shrink-0"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
      ),
      element: <GeneralSettings />,
    },
    {
      name: "Security",
      logo: (
        <svg
          class="h-6 w-6 shrink-0 text-gray-400 group-hover:text-indigo-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M7.864 4.243A7.5 7.5 0 0119.5 10.5c0 2.92-.556 5.709-1.568 8.268M5.742 6.364A7.465 7.465 0 004.5 10.5a7.464 7.464 0 01-1.15 3.993m1.989 3.559A11.209 11.209 0 008.25 10.5a3.75 3.75 0 117.5 0c0 .527-.021 1.049-.064 1.565M12 10.5a14.94 14.94 0 01-3.6 9.75m6.633-4.596a18.666 18.666 0 01-2.485 5.33"
          />
        </svg>
      ),
      element: <SecuritySettings />,
    },
  ];

  const [currentNav, setCurrentNav] = useState(navs[0]);

  return (
    <>
      <main class="-mt-24 min-h-[75vh]">
        <div class="mx-auto max-w-[86rem] py-3 sm:px-6 lg:px-8">
          <div class="flex flex-1 space-x-4">
            <section
              aria-labelledby="primary-heading"
              class="flex h-full min-w-0 flex-1 flex-col lg:order-last"
            >
              <div class="h-full">
                <div class="relative min-h-[75vh]  w-full overflow-hidden bg-white rounded-lg shadow px-4">
                  <div class="p-2">
                    <div class="flow-root">
                      <div class="-mx-4 -my-2 sm:-mx-6 lg:-mx-8">
                        <div class="inline-block min-w-full py-4 align-middle sm:px-6 lg:px-7">
                          <div className="flex gap-x-16 p-3 align-middle sm:px-6 lg:px-8">
                            <div className="absolute text-lg font-semibold leading-6 text-gray-900 w-[90%]">
                              <h3>Settings</h3>
                            </div>
                            <aside class="flex overflow-x-auto border-b border-gray-900/5 py-4 lg:block lg:w-64 lg:flex-none lg:border-0 lg:py-20">
                              <nav class="flex-none px-4 sm:px-6 lg:px-0">
                                <ul class="flex gap-x-3 gap-y-1 whitespace-nowrap lg:flex-col">
                                  {navs.map((nav) => (
                                    <li
                                      onClick={() => {
                                        setCurrentNav(nav);
                                      }}
                                      className={`cursor-pointer ${
                                        currentNav.name === nav.name
                                          ? "text-indigo-600 bg-indigo-50"
                                          : "text-gray-600 hover:text-indigo-600"
                                      } group flex gap-x-3 rounded-md py-2 pl-2 pr-3 text-sm leading-6 font-semibold`}
                                    >
                                      {nav.logo}
                                      {nav.name}
                                    </li>
                                  ))}
                                </ul>
                              </nav>
                            </aside>

                            <div className="lex py-4 grow pb-0 items-center justify-center sm:px-6 lg:px-8">
                              {/* MAIN */}
                              {currentNav.element}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
    </>
  );
}

export default Settings;
